import { useEffect, useState } from "react";
import Mode from "../../components/styles/Mode";
import { RaceBy } from "@uiball/loaders";
import { useDispatch, useSelector } from "react-redux";
import Flexbox from "../../components/Flexbox";
import Spacebox from "../../components/Spacebox";
import constant from "../../utilities/Constants";
import Grid from "../../components/Grid";
import '../../css/turboform.css'
import { BuyersTYUrl, extractUTMParameters, formatUSPhoneNumber, isPlausibleHumanName, saveTrustedFormCert, tagContactSoftCredPull } from "../../utilities/utils";
import requests from "../../handlers/requests";
import cookies from "../../utilities/Cookies";
import { updatedarkmode } from "../../features/mode";

let trials = 1

const FallbackForm = () => {
    const mode = useSelector(state => state.darkmode.value)
    const dispatch = useDispatch()

    const [maxYear,] = useState((new Date()).getFullYear() - 18)

    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    // const [contactId, setContactId] = useState(null)

    const [state, setState] = useState(constant.states[0])
    const [street, setStreet] = useState('')
    const [city, setCity] = useState('')
    const [day, setDay] = useState('')
    const [zipcode, setZipcode] = useState('')
    const [month, setMonth] = useState('')
    const [year, setYear] = useState('')

    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')


    const [error, setError] = useState(null)

    const [loading, setLoading] = useState(true)
    const [isLoading, setIsLoading] = useState(false)

    const scrollToTop = () => window.scrollTo({ behavior: 'smooth', top: 0 })

    const getParameters = () => {
        const urlParams = new URLSearchParams(window.location.search)
        // const contact_id = urlParams.get('contact_id')
        const email = urlParams.get('email')
        const phone = urlParams.get('phone')
        const dob = urlParams.get('dob')
        const street = urlParams.get('street')
        const city = urlParams.get('city')
        const zipcode = urlParams.get('zipcode')
        const amount = urlParams.get('amount')
        const contact_id = urlParams.get('contact_id')
        const first_name = urlParams.get('first_name')
        const last_name = urlParams.get('last_name')
        const page = urlParams.get('page')

        return { email, phone, dob, street, city, zipcode, amount, contact_id, first_name, last_name, page }
    }

    const main = () => {
        const urlParams = new URLSearchParams(window.location.search)
        const contact_id = urlParams.get('contact_id')
        const error_ = urlParams.get('error')
        const dob_ = urlParams.get('dob')
        const zipcode = urlParams.get('zipcode')
        const city_ = urlParams.get('city')
        const street_ = urlParams.get('street')
        const email_ = urlParams.get('email')
        const phone_ = urlParams.get('phone')
        const firstname_ = urlParams.get('first_name')
        const lastname_ = urlParams.get('last_name')


        setError(error_)
        setDay(dob_.split('-')[2]) //YYYY-MM-DD
        setMonth(dob_.split('-')[1]) //YYYY-MM-DD
        setYear(dob_.split('-')[0]) //YYYY-MM-DD
        if (zipcode && zipcode.length === 5)
            setZipcode(zipcode)
        if (zipcode && zipcode.length === 9)
            setZipcode(zipcode)
        if (zipcode && zipcode.includes('-') & zipcode.length === 10)
            setZipcode(zipcode)
        setCity(city_)
        setStreet(street_)
        setEmail(email_)
        setPhone(phone_)
        setFirstName(firstname_)
        setLastName(lastname_)
        getUserDetails(contact_id)
    }

    const getUserDetails = (contactId) => {
        requests.get(`/api/users/${contactId}`, () => { }, () => { }, () => { }, setLoading,
            (res) => {
                setState(res.data.state)
                setFirstName(res.data.first_name)
                setLastName(res.data.last_name)
            },
            null,
            null
        )
    }

    const handleChange = (event, setState) => {
        setState(event.target.value)
    }

    const handleBlur = (state, setState, max) => {
        const value = state
        if (!isNaN(parseFloat(value))) {
            let num = parseFloat(value)
            if (max >= num) {
                if (num > 0 && num < 10)
                    setState(`0${num}`)
                else
                    setState(`${num}`)
            } else {
                setState('')
            }
        }
    }

    const softCreditPull = () => {
        // check all fields
        if (!verify())
            return

        console.log(trials)
        // check trials
        if (trials > 2)
            return failedSoftCreditPull()

        const { contact_id } = getParameters()
        setIsLoading(true)
        // begin soft cred pull
        requests.get(`/api/retell/v3/product-offer?firstname=${firstName}&lastname=${lastName}&email=${email}&phone=${phone}&dob=${year}-${month}-${day}&address=${street}&city=${city}&zipcode=${zipcode.trim()}`, () => { }, () => { }, setError, setIsLoading,
            (res) => {

                const { amount, page } = getParameters()

                // if sent to turbo
                if (res.url) {
                    const user = res.data
                    const ty_page = BuyersTYUrl.get(res.buyer).replaceAll('-valid', '') // https://www.finaldebt.com/success-valid-[buyer]- = https://www.finaldebt.com/success-[buyer]- |  https://www.finaldebt.com/success-[buyer]-

                    const full_url = `${ty_page}${page}1?first_name=${user.first_name}&last_name=${user.last_name}&debt_amount=${user.debt_amount}&phone=${user.phone}&email=${user.email}&zip=${user.zipcode}&url=${res.url ?? ''}${extractUTMParameters(['cluid', 'utm_source', 'utm_medium', 'utm_content', 'utm_campaign', 'utm_term', 'utm_id', 'ad_id', 'tw_source', 'tw_adid', 'trusted_form_cert_url'])}`

                    // send to buyer's thank you page
                    return window.location.replace(full_url)
                }

                // check if server responded with buyer (Either False Buyer or frozen credit report)
                if (res.buyer) {
                    if (res.buyer === 'frozen credit report') {
                        goToFailedSoftCreditPullPage(contact_id, amount)
                    } else {
                        const { page } = getParameters()
                        let url = page ? `https://www.finaldebtrelief.com/ddq-${page}` : `https://www.finaldebtrelief.com/ddq-lf`
                        window.location.replace(`${url}?email=${email}&phone=${phone}&amount=${amount}&contact_id=${contact_id}&${extractUTMParameters(['cluid', 'utm_source', 'utm_medium', 'utm_content', 'utm_campaign', 'utm_term', 'utm_id', 'ad_id', 'tw_source', 'tw_adid', 'first_name', 'last_name', 'page', 'trusted_form_cert_url'])}`)
                    }
                } else {
                    // check is response has data.buyer
                    if (res.data?.buyer !== null) {
                        // go to dynamic buyers page
                        goToDynamicBuyersPage(contact_id, amount, res.data?.buyer)
                    } else
                        if (res.data?.ndr_error && res.data?.ndr_error === "outside coverage")
                            gotoDqPage()
                        else
                            goToResultPage(contact_id, amount) // go to results page

                }

            },
            null,
            async (res) => {

                if (res.source)
                    return goToDupPage() // source means error's from Turbo

                setError(res.msg)
                scrollToTop()
                trials = trials + 1
                await tagContactSoftCredPull(contact_id, trials)
            }
        )
    }

    const goToResultPage = (contact_id, amount) => {
        const { first_name, last_name } = getParameters()
        if (!isNaN(amount))
            if (parseFloat(amount) > 20_000)
                window.location.replace(`https://www.finaldebtrelief.com/over20-result-re1?email=${email}&phone=${phone}&amount=${amount}&contact_id=${contact_id}&first_name=${first_name}&last_name=${last_name}${extractUTMParameters(['cluid', 'utm_source', 'utm_medium', 'utm_content', 'utm_campaign', 'utm_term', 'utm_id', 'ad_id', 'tw_source', 'tw_adid', 'first_name', 'last_name', 'page', 'trusted_form_cert_url'])}`)
            else
                window.location.replace(`https://www.finaldebtrelief.com/under20-result-re1?email=${email}&phone=${phone}&amount=${amount}&contact_id=${contact_id}&first_name=${first_name}&last_name=${last_name}${extractUTMParameters(['cluid', 'utm_source', 'utm_medium', 'utm_content', 'utm_campaign', 'utm_term', 'utm_id', 'ad_id', 'tw_source', 'tw_adid', 'first_name', 'last_name', 'page', 'trusted_form_cert_url'])}`)
        else
            window.location.replace(`https://www.finaldebtrelief.com/over20-result-re1?email=${email}&phone=${phone}&amount=${amount}&contact_id=${contact_id}&first_name=${first_name}&last_name=${last_name}${extractUTMParameters(['cluid', 'utm_source', 'utm_medium', 'utm_content', 'utm_campaign', 'utm_term', 'utm_id', 'ad_id', 'tw_source', 'tw_adid', 'first_name', 'last_name', 'page', 'trusted_form_cert_url'])}`)
    }

    const goToDynamicBuyersPage = (contact_id, amount, buyer) => {
        const { first_name, last_name } = getParameters()
        if (!isNaN(amount))
            if (parseFloat(amount) > 20_000)
                window.location.replace(`https://www.finaldebtrelief.com/over20-dbp1?email=${email}&phone=${phone}&amount=${amount}&contact_id=${contact_id}&first_name=${first_name}&last_name=${last_name}&buyer=${buyer}${extractUTMParameters(['cluid', 'utm_source', 'utm_medium', 'utm_content', 'utm_campaign', 'utm_term', 'utm_id', 'ad_id', 'tw_source', 'tw_adid', 'first_name', 'last_name', 'page', 'trusted_form_cert_url'])}`)
            else
                window.location.replace(`https://www.finaldebtrelief.com/under20-dbp1?email=${email}&phone=${phone}&amount=${amount}&contact_id=${contact_id}&first_name=${first_name}&last_name=${last_name}&buyer=${buyer}${extractUTMParameters(['cluid', 'utm_source', 'utm_medium', 'utm_content', 'utm_campaign', 'utm_term', 'utm_id', 'ad_id', 'tw_source', 'tw_adid', 'first_name', 'last_name', 'page', 'trusted_form_cert_url'])}`)
        else
            window.location.replace(`https://www.finaldebtrelief.com/over20-dbp1?email=${email}&phone=${phone}&amount=${amount}&contact_id=${contact_id}&first_name=${first_name}&last_name=${last_name}&buyer=${buyer}${extractUTMParameters(['cluid', 'utm_source', 'utm_medium', 'utm_content', 'utm_campaign', 'utm_term', 'utm_id', 'ad_id', 'tw_source', 'tw_adid', 'first_name', 'last_name', 'page', 'trusted_form_cert_url'])}`)
    }

    const goToFailedSoftCreditPullPage = (contact_id, amount) => {
        const { last_name, first_name } = getParameters()
        window.location.replace(`https://www.finaldebtrelief.com/no-cred-re1?first_name=${first_name}&last_name=${last_name}&email=${email}&phone=${phone}&amount=${amount}&contact_id=${contact_id}${extractUTMParameters(['cluid', 'utm_source', 'utm_medium', 'utm_content', 'utm_campaign', 'utm_term', 'utm_id', 'ad_id', 'tw_source', 'tw_adid', 'first_name', 'last_name', 'page', 'trusted_form_cert_url'])}`)
    }

    const goToDupPage = () => {
        const { page, email, phone, amount, contact_id } = getParameters()

        // goToResultPage(contact_id, amount)

        window.location.replace(`https://www.finaldebtrelief.com/dup-error-${page}?email=${email}&phone=${phone}&amount=${amount}&contact_id=${contact_id}&${extractUTMParameters(['cluid', 'utm_source', 'utm_medium', 'utm_content', 'utm_campaign', 'utm_term', 'utm_id', 'ad_id', 'tw_source', 'tw_adid', 'first_name', 'last_name', 'page', 'trusted_form_cert_url'])}`)
    }

    const gotoDqPage = () => {
        const { page, email, phone, amount, contact_id } = getParameters()

        window.location.replace(`https://www.finaldebtrelief.com/dq-${page}?email=${email}&phone=${phone}&amount=${amount}&contact_id=${contact_id}&${extractUTMParameters(['cluid', 'utm_source', 'utm_medium', 'utm_content', 'utm_campaign', 'utm_term', 'utm_id', 'ad_id', 'tw_source', 'tw_adid', 'first_name', 'last_name', 'page', 'trusted_form_cert_url'])}`)
    }

    const failedSoftCreditPull = () => {
        const { contact_id, amount } = getParameters()
        setIsLoading(true)
        requests.get(`/api/users/${contact_id}/update/array_failed/true`, () => { }, () => { }, () => { }, setIsLoading,
            (res) => {
                goToFailedSoftCreditPullPage(contact_id, amount)
            }, null, null
        )
        // fall back incase request fails
        setTimeout(() => {
            goToFailedSoftCreditPullPage(contact_id, amount)
        }, 5000)
    }


    const verify = () => {
        if (isPlausibleHumanName(firstName) && isPlausibleHumanName(lastName)) {
            if (city !== '' && street !== '') {
                if (day !== '' && month !== '' && year !== '')
                    if (zipcode.trim().length === 5 || zipcode.trim().length === 10)
                        return true
                    else
                        setError('Invalid zip code, Please provide a valid zip code')
                else
                    setError('Provide a valid date of birth!')
            } else {
                setError('Some information are not provided!')
            }
        } else {
            setError('Invalid user name, Please provide a valid name!')
        }
        return false
    }

    const formatErrorMessage = (msg) => {
        if (msg.toLowerCase().includes('some information'))
            return 'Your information is incorrect, please verify your information and try again!'

        return msg
    }

    useEffect(() => {
        cookies.setCookies('mode', 'light', 10)
        dispatch(updatedarkmode({ dark: false }))
        scrollToTop()

        main()
        const { tcert, contact_id } = getParameters()
        saveTrustedFormCert(tcert, contact_id)
        // eslint-disable-next-line
    }, [])

    const Wrapper = ({ children }) => (
        <div style={{ padding: '20px', border: '1px solid #264375', borderRadius: '10px', background: 'white' }}>
            {children}
        </div>
    )

    return (
        <Mode>
            <div className="turbo-form-page" style={{ padding: '0px' }}>
                {loading && <Flexbox justifyContent="center" alignItems="center" style={{ height: '90dvh', width: '100%' }}>
                    <RaceBy size={40} speed={0.9} color={mode.dark ? "white" : "black"} />
                </Flexbox>}
                {(!loading) && (
                    <div className="margin-auto mid " style={{}}>
                        <div className="survey-copy">
                            <div className="margin-auto" style={{ padding: '40px' }}>
                                <span style={{ fontWeight: '700', fontSize: 30, textAlign: 'center', display: 'block' }} className="text-white heading bold hide-on-med-and-down">
                                    You're Eligible for Debt Relief
                                </span>
                                <span style={{ fontWeight: '700', fontSize: 22, textAlign: 'center', display: 'block' }} className="text-white heading bold hide-on-large-only">
                                    You're Eligible for Debt Relief
                                </span>
                                <Spacebox padding="10px" />
                                <div style={{ background: '#ef911520', padding: '5px', textAlign: 'center' }}>
                                    <span className="trade-warning" style={{ fontSize: 18, fontWeight: 700 }}>
                                        Good news! your results are ready.
                                    </span>
                                </div>
                                <Spacebox padding="5px" />
                                <div style={{ textAlign: 'center' }}>
                                    <span className="text-white" style={{ fontSize: 14, fontWeight: 700 }}>
                                        See how much you could potentially save and what your simplified monthly program payment could look like.
                                    </span>
                                </div>

                                <Spacebox padding="20px" />
                                <Wrapper>
                                    <span style={{ fontWeight: '700', fontSize: 20, textAlign: 'left', display: 'block' }} className="text-primary heading bold hide-on-med-and-down">
                                        Verify Your Phone To Unlock Your Custom Results
                                    </span>
                                    <span style={{ fontWeight: '700', fontSize: 18, textAlign: 'left', display: 'block' }} className="text-primary heading bold hide-on-large-only">
                                        Verify Your Phone To Unlock Your Custom Results
                                    </span>
                                    <Spacebox padding="10px" />
                                    <small><b>Phone *</b></small>
                                    <Spacebox padding="2px" />
                                    {phone !== '' && <small className="trade-green">
                                        <b> Your phone {formatUSPhoneNumber(phone)} has been successfully verified.</b>
                                    </small>}
                                </Wrapper>

                                <Spacebox padding="20px" />
                                <Wrapper>
                                    {/* Error message */}
                                    {error && <div>
                                        {/* <div style={{ background: 'rgba(255, 0, 0, 0.05)', padding: '10px', textAlign: 'center' }}>
                                            <Flexbox alignItems="center">
                                                <img src="/svgs/alert-circle-red.svg" alt="warning" style={{ width: 20 }} />
                                                <Spacebox padding="5px" />
                                                <span>
                                                    <b className="trade-red">{error}</b>
                                                </span>
                                            </Flexbox>
                                        </div> */}
                                        <span style={{ fontWeight: '700', fontSize: 20, textAlign: 'left', display: 'block' }} className="trade-red heading bold">
                                            {formatErrorMessage(error)}
                                        </span>
                                        <Spacebox padding="10px" />
                                    </div>}
                                    <Grid grid={2} gap='10px'>
                                        <div>
                                            <small style={{ fontSize: 14 }} className="open-sans"><b>First Name</b></small>
                                            <Spacebox padding="2px" />
                                            <input
                                                type="text"
                                                placeholder={"First Name"}
                                                value={firstName}
                                                onChange={(e) => setFirstName(e.target.value)}
                                            />
                                        </div>
                                        <div>
                                            <small style={{ fontSize: 14 }} className="open-sans"><b>Last Name</b></small>
                                            <Spacebox padding="2px" />
                                            <input
                                                type="text"
                                                placeholder="Last Name"
                                                value={lastName}
                                                onChange={(e) => setLastName(e.target.value)}
                                            />
                                        </div>
                                    </Grid>
                                    <Spacebox padding="10px" />
                                    <div>
                                        <small style={{ fontSize: 14 }} className="open-sans"><b>Street Address</b></small>
                                        <Spacebox padding="2px" />
                                        <input
                                            type="text"
                                            placeholder="Street Adress"
                                            value={street}
                                            onChange={(e) => setStreet(e.target.value)}
                                        />
                                    </div>
                                    <Spacebox padding="10px" />
                                    <Grid grid={2} gap='10px'>
                                        <div>
                                            <small style={{ fontSize: 14 }} className="open-sans"><b>City</b></small>
                                            <Spacebox padding="2px" />
                                            <input
                                                type="text"
                                                placeholder={"City"}
                                                value={city}
                                                onChange={(e) => setCity(e.target.value)}
                                            />
                                        </div>
                                        <div>
                                            <small style={{ fontSize: 14 }} className="open-sans"><b>State of Residence</b></small>
                                            <Spacebox padding="5px" />
                                            <select
                                                value={state}
                                                onChange={(e) => setState(e.target.value)}
                                                name="no-name"
                                            >
                                                {(constant.states).map((st, i) => (
                                                    <option key={i} value={st}>{st}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </Grid>
                                    <Spacebox padding="10px" />
                                    <div style={{ width: '50%' }}>
                                        <small style={{ fontSize: 14 }} className="text-primary open-sans"><b>Date of Birth</b></small>
                                        <Spacebox padding="2px" />
                                        <Grid grid={4} gap="10px">
                                            <div>
                                                <input
                                                    type="text"
                                                    value={month}
                                                    onChange={(e) => handleChange(e, setMonth)}
                                                    onBlur={() => handleBlur(month, setMonth, 12)}
                                                    inputMode="numeric"
                                                    placeholder="01"
                                                    maxLength={2}
                                                    pattern="[0-9]{1,2}"
                                                    style={{ textAlign: 'center' }}
                                                />
                                                <Spacebox padding="2px" />
                                                <div style={{ textAlign: 'center' }}>
                                                    <small className="open-sans text-primary">Month (MM)</small>
                                                </div>
                                            </div>
                                            <div>
                                                <input
                                                    type="text"
                                                    value={day}
                                                    onChange={(e) => handleChange(e, setDay)}
                                                    onBlur={() => handleBlur(day, setDay, 31)}
                                                    inputMode="numeric"
                                                    placeholder="01"
                                                    maxLength={2}
                                                    pattern="[0-9]{1,2}"
                                                    style={{ textAlign: 'center' }}
                                                />
                                                <Spacebox padding="2px" />
                                                <div style={{ textAlign: 'center' }}>
                                                    <small className="open-sans text-primary">Day (DD)</small>
                                                </div>
                                            </div>
                                            <div style={{ gridColumn: '3/5' }}>
                                                <input
                                                    type="text"
                                                    value={year}
                                                    onChange={(e) => handleChange(e, setYear)}
                                                    onBlur={() => handleBlur(year, setYear, maxYear)}
                                                    inputMode="numeric"
                                                    placeholder="1979"
                                                    maxLength={4}
                                                    pattern="[0-9]{1,4}"
                                                    style={{ textAlign: 'center' }}
                                                />
                                                <Spacebox padding="2px" />
                                                <div style={{ textAlign: 'center' }}>
                                                    <small className="open-sans text-primary">Year <br /> (YYYY)</small>
                                                </div>
                                            </div>
                                        </Grid>
                                        <Spacebox padding="10px" />
                                        <small style={{ fontSize: 14 }} className="text-primary open-sans"><b>Zip Code</b></small>
                                        <Spacebox padding="2px" />
                                        <input
                                            type="text"
                                            value={zipcode}
                                            onChange={(e) => {
                                                const digits = e.target.value.replace(/\D/g, '').slice(0, 9);
                                                const formatted = digits.length <= 5
                                                    ? digits
                                                    : `${digits.slice(0, 5)}-${digits.slice(5, 9)}`;
                                                setZipcode(formatted);
                                            }}
                                            inputMode="numeric"
                                            autoComplete="postal-code"
                                            pattern="^\d{5}(-\d{4})?$"
                                            maxLength={10}
                                            style={{ textAlign: 'center' }}
                                        />
                                    </div>
                                </Wrapper>
                                <Spacebox padding="10px" />
                                <Wrapper>
                                    <Flexbox justifyContent="center">
                                        <small className="terms hide-on-med-and-down" style={{ opacity: .5, fontSize: 10 }}>
                                            <b>We value your privacy.</b>  By clicking the button above you consent to having your credit report accessed as explained underneath. This will not impact your credit. You understand that by clicking on the button above, you are providing written instructions to our <u>partner/ affiliates <span>TurboDebt, Beyond Finance LLC dba Accredited Debt Relief, First Choice Debt Relief, National Debt Relief and Cura Debt</span> </u> under the Fair Credit Reporting Act (and all relevant State Laws) authorizing them to obtain information from your personal credit report or other information from a credit bureau for debt settlement purposes only.
                                        </small>
                                        <small className="terms hide-on-large-only" style={{ opacity: .5, fontSize: 8, lineHeight: '13px' }}>
                                            <b>We value your privacy.</b>  By clicking the button above you consent to having your credit report accessed as explained underneath. This will not impact your credit. You understand that by clicking on the button above, you are providing written instructions to our <u>partner/ affiliates <span>TurboDebt, Beyond Finance LLC dba Accredited Debt Relief, First Choice Debt Relief, National Debt Relief and Cura Debt</span> </u> under the Fair Credit Reporting Act (and all relevant State Laws) authorizing them to obtain information from your personal credit report or other information from a credit bureau for debt settlement purposes only.
                                        </small>
                                    </Flexbox>
                                </Wrapper>
                                <Spacebox padding="10px" />
                                <div onClick={softCreditPull} style={{ background: 'rgb(255, 161, 0)', padding: '15px 0px', cursor: 'pointer', width: '100%', borderRadius: '5px', textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <b style={{ fontSize: 15 }} className="text-white">
                                        {!isLoading && "See Your Savings Estimate Now"}
                                        {isLoading && "PLEASE WAIT..."}
                                    </b>
                                    <Spacebox padding="10px" />
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </Mode >
    );
}

export default FallbackForm;